/** @file The line after an import that tells the person Auto-rig builds the rig from the imported layers. */
import type { Translate } from '@pose2d/i18n/types';
import type { ImportOutcome } from './importTypes';

/** Imported images alone give an empty viewport and Hierarchy (importLayers creates no slots), so the next step is named. */
export function ImportDone({ t, outcome }: { t: Translate; outcome: Pick<ImportOutcome, 'images'> }) {
  if (outcome.images === 0) return null;
  return <p className="import-note import-next">{t('psdImport.nextAutorig', { panel: t('autorig.title'), action: t('autorig.fn.autoRig') })}</p>;
}
